import plugin, { install } from '@ustra/nuxt/src/vue/plugins/ustra-plugin'
import { ModuleNameKeys } from '@ustra/nuxt/src/vue/plugins/modules/keys'
import Middleware from '../middleware'

const moduleMap = {}

install(Middleware)
export default (context, inject) => plugin(context, inject, moduleMap)
